import { useSubscription } from '@apollo/client';
import { useMemo } from 'react';

import {
  Alert,
  AlertDescription,
  AlertTitle,
  LoadingIcon,
} from '@eluve/components';

import { pendingTranscriptionFilesSubscriptions } from './useAppointmentTranscriptionPendingFiles';

interface PendingTranscriptionLoaderProps {
  tenantId: string;
  appointmentId: string;
}

export const PendingTranscriptionLoader: React.FC<
  PendingTranscriptionLoaderProps
> = ({ tenantId, appointmentId }) => {
  const { data: pendingFiles } = useSubscription(
    pendingTranscriptionFilesSubscriptions,
    {
      variables: { tenantId, id: appointmentId },
    },
  );

  const pendingFilesCountToTranscribe = useMemo(() => {
    const files = pendingFiles?.appointmentsByPk?.appointmentFiles;
    return files?.length ?? 0;
  }, [pendingFiles]);

  if (pendingFilesCountToTranscribe === 0) {
    return null;
  }

  return (
    <Alert variant="default" ref={(e) => e?.scrollIntoView()}>
      <LoadingIcon size="lg" className="mr-4" />
      <AlertTitle>Analyzing audio</AlertTitle>
      <AlertDescription>
        Analyzing audio to improve accuracy. ({pendingFilesCountToTranscribe})
        files remain.
      </AlertDescription>
    </Alert>
  );
};
